import { cn } from '@/utils/tailwind-util';
import { useLocation } from 'react-router-dom';

import Footer from './components/Footer';
import Menu from './components/Menu';
import MobileHeader from './components/MobileHeader';

const isLayoutVisible = () => {
  const { pathname } = useLocation();
  const isNoticeDetailOrEdit =
    /\/notices\/\d+(\/edit)?$/.test(pathname) ||
    /\/notices\/new$/.test(pathname);
  const isGroupDetail = /\/venue\/-?\d+\/group\/-?\d+$/.test(pathname);

  return !(isNoticeDetailOrEdit || isGroupDetail);
};
const isMobileHeaderVisible = () => {
  const { pathname } = useLocation();
  const isAlarmcenter = /\/alarmcenter$/.test(pathname);
  return !isAlarmcenter;
};

const Layout = ({ children }) => (
  <div>
    <div className="h-full w-full flex-col max-md:h-screen">
      <div className="max-md:hidden">
        <Menu />
      </div>

      <div
        className={cn(
          'md:hidden',
          (!isLayoutVisible() || !isMobileHeaderVisible()) && 'hidden'
        )}
      >
        <MobileHeader />
      </div>

      <div
        id="layout_body"
        className="h-main-h overflow-y-auto max-md:h-full scroll-smooth"
      >
        {children}
      </div>
      <div className={cn('md:hidden', !isLayoutVisible() && 'hidden')}>
        <Footer />
      </div>
    </div>
  </div>
);

export default Layout;
